import Cookies from "js-cookie";

// state
export const state = {
  option: Cookies.get("customer-option")
    ? JSON.parse(Cookies.get("customer-option"))
    : 0,
};

// mutations
export const mutations = {
  SET_OPTION: (state, data) => {
    Cookies.set("customer-option", data, { expires: 365 });
    state.option = data;
  },
  REMOVE_OPTION: (state) => {
    Cookies.remove("customer-option");
    state.option = 0;
  },
};

// actions
export const actions = {
  setOption({ commit }, payload) {
    commit("SET_OPTION", payload);
  },
  removeOption({ commit }) {
    commit("REMOVE_OPTION");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
